 import { 
  statusMedecinTypeStart,
  statusMedecinTypeSuccess,
  statusMedecinTypeFailure 
} from "./medecinTypeSlice";

import { get, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getMedecinTypesApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusMedecinTypeStart())
    let response = await get(`medecinType`)
    const resData = response.data.success
    if(resData) {
      dispatch(statusMedecinTypeSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusMedecinTypeFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusMedecinTypeFailure(errData))
      return [errData]
    }
  }
}

export const AddMedecinTypeApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusMedecinTypeStart())
    let response = await post(`medecinType`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusMedecinTypeSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusMedecinTypeFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusMedecinTypeFailure(errData))
      return [errData]
    }
  }
}

export const EditMedecinTypeApi = (medecinTypeId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusMedecinTypeStart())
    let response = await put(`medecinType/${medecinTypeId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusMedecinTypeSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusMedecinTypeFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusMedecinTypeFailure(errData))
      return [errData]
    }
  }
}

export const DeleteMedecinTypeApi = (medecinTypeId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusMedecinTypeStart())
    let response = await remove(`medecinType/${medecinTypeId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusMedecinTypeSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusMedecinTypeFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusMedecinTypeFailure(errData))
      return [errData]
    }
  }
}

export const clearMedecinTypeApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusMedecinTypeSuccess([]))
}
